import { render, staticRenderFns } from "./TabSet.vue?vue&type=template&id=10bf522e&"
import script from "./TabSet.vue?vue&type=script&lang=js&"
export * from "./TabSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports